import { Input } from 'antd';
import { TextAreaProps } from 'antd/es/input';
import { TextAreaRef } from 'antd/lib/input/TextArea';
import { forwardRef } from 'react';
import { ControllerRenderProps, useFormContext } from 'react-hook-form';

interface IProps extends TextAreaProps {
  field?: ControllerRenderProps<any, any>;
}

export const TextArea = forwardRef<TextAreaRef, IProps>(
  ({ className, field, ...props }, ref) => {
    const context = useFormContext();
    return (
      <Input.TextArea
        ref={ref}
        className={className}
        {...field}
        {...props}
        onBlur={(event: React.FocusEvent<HTMLTextAreaElement, Element>) =>
          context?.setValue(props?.name as string, event?.target?.value?.trim())
        }
      />
    );
  },
);
